import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {faPen, faToggleOff, faToggleOn} from '@fortawesome/free-solid-svg-icons';
import {BackofficeLightDto, BackofficeService, SortDirection} from '../../_services/configuration-services';
import * as fileSaver from 'file-saver';

@Component({
    selector: 'app-backoffices',
    templateUrl: './backoffices.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BackofficesComponent implements OnInit {

    icons = {
        edit: faPen,
        toggleOn: faToggleOn,
        toggleOff: faToggleOff
    };

    backoffices: BackofficeLightDto[] = [];

    readonly defaultSortProperty = 'lastName';

    private sortProperty: string = this.defaultSortProperty;
    private sortDirection: SortDirection = SortDirection.Asc;

    constructor(private readonly backofficeService: BackofficeService) {
    }

    ngOnInit(): void {
        this.loadBackoffices();
    }

    onSort(sortingValues: any): void {
        this.sortProperty = sortingValues.sorts[0].prop;
        this.sortDirection = sortingValues.sorts[0].dir === 'desc' ? SortDirection.Desc : SortDirection.Asc;
        this.loadBackoffices();
    }

    exportBackoffices(): void {
        this.backofficeService.exportBackoffices().subscribe(response => {
            fileSaver.saveAs(response.data, response.fileName);
        });
    }

    private loadBackoffices(): void {
        this.backofficeService.getAllBackoffices(this.sortProperty, this.sortDirection).subscribe(data => {
            this.backoffices = data;
        });
    }
}
